export default {"src":"/_next/static/media/uhc.25fe7ef0.svg","height":69,"width":444};